const convertDate = (date, from, to) => {
  if (!date) {
    return '';
  }
  try {
    return date
      .split(from)
      .reverse()
      .join(to);
  } catch (err) {
    return '';
  }
};

export const convertFromDDMMYYYY = dateString => convertDate(dateString, '/', '-');

export const convertFromYYYYMMDD = dateString => convertDate(dateString, '-', '/');
